import React, { useState } from 'react';
import axios from 'axios';
import config from 'config';
import { makeStyles } from '@mui/styles';

import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Card from 'components/Card';
import Button from 'components/Button';
import IOSSwitch from 'components/Switch';
import CardItem from 'components/CardItem';

export default function CardGrupo(props) {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(props.group.status);

  async function toggleStatus(group) {
    await axios.put(`${config.server}groups/${group.id}`, {
      status: !active,
    });
  }

  function handleClickOpen(group) {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  async function confirmOption(group) {
    setOpen(false);
    setActive(!active);
    toggleStatus(group);
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Habilitar grupo</DialogTitle>
        <DialogContent>
          <DialogContentText>Deseja habilitar o grupo?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            outline={1}
            onClick={handleClose}
            color="primary"
            style={{ color: '#494950', borderColor: '#494950' }}
          >
            Cancelar
          </Button>
          <Button onClick={() => confirmOption(props.group)} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Grid item xs={12} style={{ width: '100%', maxWidth: '720px' }}>
        <Card
          style={{
            marginTop: '10px',
          }}
        >
          <div style={{ padding: '14px 16px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '16px',
              }}
            >
              <CardItem className="nameClients">{props.group.name}</CardItem>
              <FormControlLabel
                style={{
                  color: '#76838F',
                  marginRight: 0,
                }}
                control={
                  <IOSSwitch
                    checked={active}
                    value={active}
                    onClick={() => handleClickOpen(props.group)}
                  />
                }
                labelPlacement="start"
                label={active ? 'ativo' : 'inativo'}
              />
            </div>
            <hr style={{ margin: '12px 0' }} />
            <Link
              style={{
                fontWeight: 'bold',
                textTransform: 'uppercase',
                cursor: 'pointer',
                display: 'inline-block',
              }}
              onClick={() => props.handleOpened(props.group)}
            >
              Ver / Editar
            </Link>
          </div>
        </Card>
      </Grid>
    </>
  );
}
